<div class="jumbotron">
	<div class="centered-text" *ngIf="!saving">Na <b>{{data.details.group.cases.length}}</b> případech bude provedena změna stavu na <b>{{data.details.group.caseStatus.name}}</b>.</div>
	<div class="centered-text" *ngIf="saving">
		<b>{{processed}}/{{data.details.group.cases.length}}</b>
		<div [loading]="true"></div>
	</div>
</div>
